<template>
  <div class="" :class="cardGridClasses">
    <card type="secondary" shadow hover
      bodyClasses="p-1"
      :class="cardClasses">
      <template>
        <div class="ph-col-12 ph-cover-small"></div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card';

export default {
  name: "movieCardPlaceholder",
  components: {
    Card,
  },
  props: {
    cardGridClasses: {
      type: [String, Object, Array],
      default: "col-6 col-md-4 col-lg-3 mb-4",
      description: "Individual card grid css classes"
    },
    cardClasses: {
      type: [String, Object, Array],
      default: "bg-white border-0",
      description: "Individual card css classes"
    }
  }
};
</script>
<style>
  .ph-cover-small {
    height: 330px;
    display: block;
    margin-bottom: -5px;
  }
</style>
